import browser from '@openclassrooms/utils/browser';
import isPath from './isPath';
import ROUTES from '../constants/routes';

export default function isOnTalentPoolPage() {
  return isPath(browser.document.location.pathname, [
    ROUTES.TALENTS.LIST,
    ROUTES.BUSINESS.UPLIFT,
    ROUTES.TEAMS.TALENTS,
    ROUTES.ORGANIZATIONS.TALENTS,
  ]);
}
